module.exports = __webpack_public_path__ + "static/media/techno-5.662b432a.png";